import React, { ChangeEvent, useRef } from 'react';

interface UploadImageProps {
  logoFile: File[];
  setLogoFile: React.Dispatch<React.SetStateAction<File[]>>;
  logoPreviewURL: string[];
  setLogoPreviewURL: React.Dispatch<React.SetStateAction<string[]>>;
  name: string;
}

const UploadImage: React.FC<UploadImageProps> = ({
    logoFile,
    setLogoFile,
    logoPreviewURL,
  setLogoPreviewURL,
  name,
}) => {
  // Create a ref for the file input
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleStyleframesChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    const newFiles = Array.from(e.target.files);

    // Add new files to existing
    setLogoFile((prev) => [...prev, ...newFiles]);

    // Generate previews
    newFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result;
        if (typeof result === 'string') {
            setLogoPreviewURL((prev) => [...prev, result]);
        }
      };
      reader.readAsDataURL(file);
    });

    // Reset the file input's value to allow re-uploading the same file
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleRemovePreview = (index: number) => {
    setLogoFile((prev) => {
      const copy = [...prev];
      copy.splice(index, 1);
      return copy;
    });
    setLogoPreviewURL((prev) => {
      const copy = [...prev];
      copy.splice(index, 1);
      return copy;
    });
  };

  return (
    <div>
      <label className="block text-gray-700 font-medium mb-1">
        Upload {name}:
      </label>
      {/* Hidden real input with ref */}
      <input
        id="styleframesFile"
        type="file"
        multiple
        accept="image/*"
        onChange={handleStyleframesChange}
        className="hidden"
        ref={fileInputRef} // Attach the ref here
      />

      {/* Faux button + file count */}
      <div className="flex items-center gap-2">
      <label
        htmlFor="styleframesFile"
        className="cursor-pointer px-4 py-2 text-base font-medium text-neutral-950 bg-neutral-50 border border-neutral-950 rounded-full"
      >
            Upload
      </label>
        {logoFile.length > 0 && (
          <span className="text-sm text-gray-700">
            {logoFile.length} file(s) selected
          </span>
        )}
      </div>

      {/* Image previews */}
      {logoPreviewURL.length > 0 && (
        <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {logoPreviewURL.map((url, idx) => (
            <div key={idx} className="relative">
              <img
                src={url}
                alt={`Preview ${idx + 1}`}
                className="max-w-full h-auto rounded-md border"
              />
              <button
                type="button"
                onClick={() => handleRemovePreview(idx)}
                className="absolute top-2 right-2 bg-red-600 text-white text-sm px-2 py-1 rounded"
              >
                Remove
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UploadImage;
